<script lang="ts" setup>
import * as gatewayTruck from '@/assets/GATEWAY_TRUCK.jpg';
</script>

<template>
  <div data-testid="home-view">
    <div class="img-container">
      <img class="img-truck" :src="gatewayTruck.default" alt="gateway-truck-image" />
    </div>
  </div>
</template>
